import React, { useState, useEffect } from "react";
import Sidebar from "../components/Sidebar";
import Navbar from "../components/Navbar";
import "./dashboardLayout.css";

const DashboardLayout = ({ children }) => {
  const isMobile = window.innerWidth < 768;

  const [isCollapsed, setIsCollapsed] = useState(isMobile);

  const toggleCollapse = () => {
    setIsCollapsed((prev) => !prev);
  };

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth < 768) {
        setIsCollapsed(true); 
      } else {
        setIsCollapsed(false);
      }
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <div className="dashboard-layout">
      <Sidebar
        isCollapsed={isCollapsed}
        toggleCollapse={toggleCollapse}
      />

      <div className={`main-content ${isCollapsed ? "collapsed" : ""}`}>
        <Navbar toggleSidebar={toggleCollapse} />
        <div className="content">{children}</div>
      </div>
    </div>
  );
};

export default DashboardLayout;
